import { __assign } from "tslib";
// extend
import { CnShell as PcCnShell } from '@cainiaofe/cn-ui';
export var CnBottomNavBar = function (props) {
    // const dialogProps = propsRender(props);
    // dialogProps.children = dialogProps.content;
    return React.createElement(PcCnShell, __assign({}, props), props.children);
};
// export * from '@cainiaofe/cn-ui-m/es/components/cn-bottom-nav-bar';
